module.exports = __webpack_public_path__ + "static/nav-decisioning-os-b5bbe6fff6ac58fe0eed3039486eed81.svg";